import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';

const StyledBody = styled.div`
    padding: 10px;
`;

const StyledInfo = styled.div`
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 14px;
    color: #333;
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

const StyledCardList = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-top: 10px;
`;

const StyledCard = styled.div`
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: auto;
    text-align: center;
    background-color: #fff;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
`;


export function ModalViewAlreadyPurchasedQty({
    open,
    onClose,
    targetAlreadyPurchasedQtyData,
}) {
    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <CustomDialog.Header style={{ padding: 10 }}>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>
                        {targetAlreadyPurchasedQtyData?.productName} - {targetAlreadyPurchasedQtyData?.productOptionName}
                    </CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={onClose} />
                </CustomDialog.Header>
                <StyledBody>
                    <StyledInfo>
                        <div>상품 옵션 코드: {targetAlreadyPurchasedQtyData?.productOptionCode}</div>
                        <div>
                            <span>상품 태그: {targetAlreadyPurchasedQtyData?.productTag}</span> ➖ <span>옵션 태그: {targetAlreadyPurchasedQtyData?.optionTag}</span>
                        </div>
                    </StyledInfo>
                    <StyledCardList>
                        <StyledCard>
                            <div>구매된 상품들</div>
                            <div>{targetAlreadyPurchasedQtyData?.purchasedQty}</div>
                        </StyledCard>
                        <StyledCard>
                            <div>배송중</div>
                            <div>{targetAlreadyPurchasedQtyData?.deliveryQty}</div>
                        </StyledCard>
                        <StyledCard>
                            <div>도착완료</div>
                            <div>{targetAlreadyPurchasedQtyData?.arrivedQty}</div>
                        </StyledCard>
                        <StyledCard>
                            <div>서류작성</div>
                            <div>{targetAlreadyPurchasedQtyData?.documentQty}</div>
                        </StyledCard>
                        <StyledCard>
                            <div>선적 +3day</div>
                            <div>{targetAlreadyPurchasedQtyData?.shippingQty}</div>
                        </StyledCard>
                    </StyledCardList>
                </StyledBody>
            </CustomDialog>
        </>
    );
}